import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 11" {...props}>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      stroke="currentColor"
      stroke-width={0.5}
      d="M1 10V1.412h2.897c2.722 0 4.645 1.776 4.645 4.288 0 2.512-1.923 4.3-4.645 4.3H1Zm.974-1.763h1.923c2.148 0 3.658-1.17 3.658-2.974 0-1.792-1.51-2.963-3.658-2.963H1.974v5.937Zm9.835-5.587.005.887h1.605v.838h-1.6L12.007 10h-1.414l.218-5.625h-.97v-.838h1.024l.03-.887C10.928 1.688 11.54 1 12.38 1c.397 0 .792.15 1.121.412l-.385.688a.904.904 0 0 0-.651-.262c-.353 0-.657.337-.655.812Z"
    />
  </svg>
);
export const DyslexiaIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
